import { queryOptions } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

export type UseCreditInfoResponse = Awaited<
  ReturnType<typeof api.getLoansCreditloanpageinfo>
>;

function getCreditInfoQuery(
  params: { contractId?: string },
  opts: RequestOpts = {},
) {
  const queryKey = ['getCreditInfo', params.contractId];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      if (!params.contractId) {
        throw new TypeError('Contract ID is required');
      }
      return api.getLoansCreditloanpageinfo(params, { ...opts, signal });
    },
    staleTime: ms('5m'),
    gcTime: ms('10m'),
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchCreditInfoQuery(
  params: { contractId?: string },
  opts: RequestOpts = {},
) {
  return queryClient.fetchQuery(getCreditInfoQuery(params, opts));
}
